var render = function () {
  var _vm$data$image;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "news-card"
  }, [_c('GGLink', {
    staticClass: "news-card__photo",
    style: {
      backgroundImage: ("url(" + ((_vm$data$image = _vm.data.image) === null || _vm$data$image === void 0 ? void 0 : _vm$data$image.x1) + ")")
    },
    attrs: {
      "to": _vm.data.path
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "news-card__title"
  }, [_c('GGLink', {
    staticClass: "cc-link cc-link_wu",
    attrs: {
      "to": _vm.data.path
    }
  }, [_vm._v("\n      " + _vm._s(_vm.data.name) + "\n    ")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }